import { useMutation } from "react-query";
import http from "infra/http";
import { ArrecadacaoForm } from "./typings/form";

function useSaveArrecadacao(id?: string) {
  return useMutation(
    [`/v1/arrecadacao`, id],
    (data: ArrecadacaoForm) => {
      if (!id) {
        return http.post(`/v1/arrecadacao`, data);
      }

      return http.put(`/v1/arrecadacao/${id}`, data);
    },
    { retry: false }
  );
}

export default useSaveArrecadacao;
